import { render, staticRenderFns } from "./VipCenterShare.vue?vue&type=template&id=5463af7e&scoped=true&"
import script from "./VipCenterShare.vue?vue&type=script&lang=js&"
export * from "./VipCenterShare.vue?vue&type=script&lang=js&"
import style0 from "./VipCenterShare.vue?vue&type=style&index=0&id=5463af7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463af7e",
  null
  
)

export default component.exports